import BlockText from "../../block-content/block-text";
import { Link } from "gatsby";
import styled from "styled-components";
import tw from "twin.macro";
import Image from "gatsby-plugin-sanity-image";
import { imageUrlFor } from "../../../lib/image-url";

const TextStyles = styled.div`
  p {
    ${tw`text-sm md:text-base mb-6`}
  }
`;

const CTABlock = (props) => {
  let ctaBlock = props.props ?? props.pageBlock;
  const section = props.section;
  const sites =
      ctaBlock.sites && Array.isArray(ctaBlock.sites)
      ? ctaBlock.sites.map(({ urlPrefix }) => urlPrefix)
      : [];
  const isViewable =
    !section || sites.length === 0 ? true : section && sites.includes(section);

  // If not viewable return early
  if (!isViewable) {
    return <></>;
  }

  if (ctaBlock.cta !== undefined) {
    ctaBlock = ctaBlock.cta;
  }
  const isImagePattern = ctaBlock.background === "bg-image-pattern";
  const isLinkExternal = ctaBlock.link && ctaBlock.link.href;
  const isLinkReference =
    ctaBlock.link && ctaBlock.link.reference && ctaBlock.link.reference.path;
  const isLinkAll = isLinkExternal && isLinkReference;
  const isLinkUndefined = !isLinkExternal && !isLinkReference;
  const assetId =
    ctaBlock.image && ctaBlock.image.asset ? ctaBlock.image.asset._id : null;

  if (isImagePattern) {
    const imageUrl = assetId
      ? imageUrlFor(assetId).auto("format").width(1920).quality(65).url()
      : "";
    const ImagePattern = styled.section`
      background: url(${({ img }) => img}) fixed top no-repeat;
      background-size: cover;
      ${tw`h-64 w-full flex items-center justify-center py-56`}
      h2 {
        ${tw`text-3xl md:text-5xl text-white tracking-tighter group-hover:text-yellow-500 font-bold mb-4`}
      }
      p {
        ${tw`md:text-lg text-white font-bold mb-4`}
      }
      a {
        ${tw`bg-blue-500 md:w-8/12 mx-auto p-4 text-center md:py-6 px-8 shadow hover:ring`}
      }
      button {
        ${tw`block md:inline-block text-sm shadow-lg uppercase text-center md:text-base px-4 md:px-6 py-3 rounded font-bold bg-yellow-500 text-yellow-900 transition hover:ring`}
      }
    `;
    const Content = ({ title, _rawBody, buttonText }) => {
      return (
        <>
          {title && <h2>{title}</h2>}
          <BlockText blocks={_rawBody} />
          {buttonText && <button>{buttonText}</button>}
        </>
      );
    };

    return (
      <ImagePattern img={imageUrl}>
        {(isLinkExternal || isLinkUndefined || isLinkAll) && (
          <a href={ctaBlock.link ? ctaBlock.link.href : false}>
            <Content {...ctaBlock} />
          </a>
        )}
        {isLinkReference && !isLinkExternal && (
          <a href={ctaBlock.link.reference.path}>
            <Content {...ctaBlock} />
          </a>
        )}
      </ImagePattern>
    );
  }

  return (
    <section
      className={`clear-both py-10 md:py-20 px-4 ${ctaBlock.background}`}
    >
      <div className="max-w-5xl mx-auto">
        <div className="sm:flex bg-white border border-gray-100 rounded shadow-xl">
          <div className="sm:w-1/2 lg:w-4/12">
            {ctaBlock.image && ctaBlock.image.asset && (
              <Image
                style={{ height: "auto", minHeight: "100%" }}
                {...ctaBlock.image}
                width={341}
                className="h-full object-center object-cover align-top"
                alt={ctaBlock.image.alt || ``}
              />
            )}
          </div>
          <div className="sm:w-1/2 lg:w-7/12 lg:mx-auto px-6 py-6">
            <h2 className="font-bold text-blue-500 tracking-tighter mb-1 sm:leading-tight md:leading-tight text-xl md:text-2xl lg:text-3xl">
              {ctaBlock.title}
            </h2>
            <TextStyles>
              <BlockText blocks={ctaBlock._rawBody} />
            </TextStyles>
            {ctaBlock.buttonText &&
              ctaBlock.link &&
              (ctaBlock.link.href ? (
                <a
                  className={`block text-sm text-center md:text-base md:inline-block px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
                  href={ctaBlock.link.href}
                >
                  {ctaBlock.buttonText}
                </a>
              ) : ctaBlock.link &&
                ctaBlock.link.reference &&
                ctaBlock.link.reference.path ? (
                <a
                    href={ctaBlock.link.reference.path}
                  className={`block text-sm text-center md:text-base px-4 md:px-6 py-3 rounded transition ease-in-out duration-200 text-teal-900 block md:inline-block bg-teal-500 uppercase tracking-tight font-bold hover:bg-blue-500 hover:text-blue-100`}
                >
                  {ctaBlock.buttonText}
                </a>
              ) : (
                "Reference page is missing its path"
              ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTABlock;
